import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '224px 1fr',
    justifyContent: 'space-between',
    width: '100%',
    gap: 230,
    paddingLeft: 40,
    marginTop: 40,
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.down(1260)]: {
      paddingLeft: 0,
      gap: 'calc((335px - 220px) + 32px)',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      marginTop: 0,
      paddingTop: 24,
      paddingBottom: 24,
      padding: '0px 16px',
      gap: 0,
      background: '#F5F6FA',
      '& .uppy-Dashboard-inner': {
        height: '168px !important',
      },
      '&::after': {
        content: "''",
        position: 'absolute',
        bottom: '-15px',
        left: 0,
        width: '100%',
        height: 20,
        background: '#F5F6FA',
        zIndex: -1,
      },
    },
  },
  illustration: {
    width: 'auto',
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    objectPosition: 'start',
    height: '35vh',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}))

export default useStyles
